// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9gmKj","cardsWrapper":"styles_cardsWrapper__KCvRK","card":"styles_card__I5xF+","cardHeader":"styles_cardHeader__TeTa8"};